<template>
    <blockquote>
        <p>{{ fundingSource.name }}</p>
        <p>xxxx-xxxx-xxxx-{{ fundingSource.lastFour }}</p>
    </blockquote>
</template>

<script type="text/babel">
    export default {
        props: { fundingSource: Object }
    }
</script>
